import React from "react";
import App from "./App";
import { jwtDecode } from "jwt-decode";
import { setUserLoggedIn } from "./store/User";
import { setPageLoading } from "./store/Page";
import Spinner from "./components/Spinner";
import { connect } from "react-redux";
import util from "./util";
import api from "./api";
import config from "./config";
import { withRouter } from "react-router-dom";
class Root extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  setFaviconEl = (iconUrl) => {
    //console.log

    const favIcon = document.getElementById("favicon");
    if (favIcon) favIcon.href = iconUrl;
  };

  // done by sagar
  componentWillMount() {
    this.props.setPageLoading({isLoading:true})
  }

  componentDidMount() {
    this.setState({ loading: true });

    //if state does not have user information and cookies is not set
    if (
      !window.location.pathname.includes("/user/auth") &&
      !this.props.user &&
      !util.getAuthTokens().access_token
    ) {
      window.location.href = config.authLogoutUrl;
    } else if (
      !window.location.pathname.includes("/user/auth") &&
      !this.props.user &&
      util.getAuthTokens().refresh_token
    ) {
      // if state does not have user but cookies have tokens then set user state
      this.loadUserInfo()
        .then((user) => {
          this.props.setUserLoggedIn({ user });

          this.setState({ loading: false });
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    } else if (window.location.pathname === "/user/auth") {
      this.authenticateUser();
      this.setState({ loading: false });
    } else {
      window.location.href = config.authLogoutUrl;
    }
  }

  authenticateUser = () => {
    const { location, history } = this.props;
    //setPageLoading({ isLoading: true });
    if (location.search) {
      let params = new URLSearchParams(location.search);
      var route = params.get("route");
      var loginvia = params.get("loginvia");
      util.setCookie("loginVia",loginvia);

      if (params.has("user")) {
        api.user
          .verifyUser(params.get("user"))
          .then((resp) => {
            const { access_token, refresh_token } = resp.data;
            if (
              resp.status === 200 &&
              access_token &&
              access_token !== "" &&
              refresh_token &&
              refresh_token !== ""
            ) {
              util.setAuthTokens(
                access_token,
                refresh_token,
                params.get("subid")
              );

              this.loadUserInfo()
                .then((user) => {
                  this.props.setUserLoggedIn({ user });
                  sessionStorage.setItem("loginVia", loginvia);

                  const isPlgAccount =
                    user.is_plg_account === true || user.is_plg_account === 1;
                  const plgDefaultLandingRoutes = new Set([
                    "dashboard",
                    "chat-dashboard",
                    "reporting",
                  ]);

                  if (
                    isPlgAccount &&
                    (!route || plgDefaultLandingRoutes.has(route))
                  ) {
                    history.push("/dashboard-overview");
                  } else if (route == 'dashboard') {
                    history.push("/");
                  } else {
                    history.push("/" + route);
                  }

                })
                .catch((err) => {
                  console.log(err.message);
                });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  };

  validateuser = () => {
    const sccestoken = util.getAuthTokens().access_token;
    const userinfo = jwtDecode(sccestoken);
    const userId = localStorage.getItem("currentUserId");
    if(!userId){
      localStorage.setItem("currentUserId", userinfo.uId);
    }
    const bc = new BroadcastChannel("admin_lock");
    bc.postMessage(userinfo.uId);
    console.log("Comparing sent user id",userinfo.uId);
    bc.onmessage = (event) => {
      const userId1 = localStorage.getItem("currentUserId");
      if(userId1 && event.data){
        console.log("Comparing user IDs - Received:", event.data, "LocalStorage user_id:", userId);
        if(userId1 != event.data){
          localStorage.removeItem("currentUserId");
          window.location.href = config.baseUrl;
        }
      }
    };
  }
  loadUserInfo = () => {
    this.validateuser();
    // this.setState({loading:true})
    const sccestoken = util.getAuthTokens().access_token;
    var subid = util.getAuthTokens().user_subaccount_id
    return api.user
      .getUserInfo({ subid: subid })
      .then((userResp) => {
        // console.log("User Full information : ",userResp );

        if (!userResp.data.user.logoUrl) {
          userResp.data.user.logoUrl =
            config.imageUrl + "/assets/media/logos/z.svg";
        }
        if (userResp.data.user.favIcon) {
          this.setFaviconEl(userResp.data.user.favIcon);
        }
        userResp.data.user.user_subaccount_id = util.getAuthTokens().user_subaccount_id;

        userResp.data.user.leftBarAccessList = userResp.data.leftBarAccessList;
        userResp.data.user.totalAvailableModules = userResp.data.totalAvailableModules;
        userResp.data.user.customizedDashboard = userResp.data.customizedDashboard;
        userResp.data.user.userBillingDetail = userResp.data.userBillingDetail;
        this.props.setPageLoading({ isLoading: false });

        return userResp.data.user;
      })
      .catch((err) => {
        this.setState({ loading: false })
        console.log(err)
      });
  };
  render() {
    return (
      <React.Fragment>
        {this.props.isPageLoading ? <Spinner /> : ""}

        {this.state.loading ? <Spinner /> : ""}

        {this.props.user && <App />}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user.company ? true : false,
    isPageLoading: state.page.isLoading ? true : false,
  };
};
export default connect(mapStateToProps, { setUserLoggedIn, setPageLoading })(
  withRouter(Root)
);
